import { useDocumentHead } from '@/hooks/use-document-head'
import { EvalTabContent } from '@/components/eval/EvalTabContent'
import { FloatingActionIsland } from '@/components/ui/FloatingActionIsland'
import { FloatingActionIslandProvider } from '@/contexts/FloatingActionIslandContext'

export function EvalPage() {
  useDocumentHead({ title: 'Evaluations' })

  return (
    <div className="h-full overflow-y-auto pt-16">
      <FloatingActionIslandProvider>
        <div className="p-6 pb-24">
          <EvalTabContent />
        </div>
        <FloatingActionIsland />
      </FloatingActionIslandProvider>
    </div>
  )
}
